import { InjectionToken } from '@angular/core'

export const APP_CONFIG: InjectionToken<AppConfiguration> = new InjectionToken<AppConfiguration>('Cognito App configuration')

export interface AppConfiguration {
    issuer: string;
    tokenEndpoint: string;
    tokenPrefix: string;
    clientId: string;
    responseType: string;
    scope: string;
    userinfoEndpoint: string;
    logoutUrl: string;
    abbreviation: string;
}
